'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ELEMENTS_LOAD = exports.ELEMENTS_LOAD = 'ELEMENTS_LOAD';
var ELEMENTS_RESET_SCORES = exports.ELEMENTS_RESET_SCORES = 'ELEMENTS_RESET_SCORES';


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementsConstants.js
// module id = 322
// module chunks = 0